import { render, staticRenderFns } from "./TournamentRanking.vue?vue&type=template&id=664a6e78&scoped=true"
import script from "./TournamentRanking.vue?vue&type=script&lang=js"
export * from "./TournamentRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664a6e78",
  null
  
)

export default component.exports